import * as THREE from 'three';
import { FikoGrup } from './FikoGrup';
import { FikoSahne } from './FikoSahne';
import { FikoVektor3D } from './FikoVektor3d';
import { TextGeometry, } from "three/examples/jsm/geometries/TextGeometry.js";
import { FontLoader, Font } from "three/examples/jsm/loaders/FontLoader.js";
import { Raycaster, Intersection, DoubleSide } from 'three';

export class Fiko3DYazi extends FikoGrup {
    static anaYaziTipi: Font;

    override type: any = "Fiko3DYazi";
    /** */
    private yaziTipiOkuyucu?: FontLoader = new FontLoader();
    yaziTipleri?: Font[] = [];
    /** */
    #__yazi: string;
    public get yazi(): string {
        return this.#__yazi;
    }
    public set yazi(v: string) {
        this.#__yazi = v;
        this.yaziDegisti();
    }
    #__boyut: number = 1;
    public get boyut(): number {
        return this.#__boyut;
    }
    public set boyut(v: number) {
        this.#__boyut = v;
        this.yaziDegisti();
    }
    #__renk: THREE.Color | number | any = new THREE.Color(0x1569C7);
    public get renk(): THREE.Color | number | any {
        return this.#__renk;
    }
    public set renk(v: THREE.Color | number | any) {
        this.#__renk.set(v)
        this.renkDegisti();
    }


    #__sabitYon: boolean = true;
    public get sabitYon(): boolean {
        return this.#__sabitYon;
    }
    public set sabitYon(v: boolean) {
        this.#__sabitYon = v;
    }


    #__sabitBoyut: boolean = true;
    public get sabitBoyut(): boolean {
        return this.#__sabitBoyut;
    }
    public set sabitBoyut(v: boolean) {
        this.#__sabitBoyut = v;
    }
    /** */
    materyal: THREE.MeshBasicMaterial = new THREE.MeshBasicMaterial(
        {
            color: this.renk,
            transparent: true,
            opacity: 1.0,
            depthTest: false,  // Derinlik testi yok - her zaman görünür
            depthWrite: false, // Derinlik buffer'a yazmaz - diğer objeleri etkilemez
            side: THREE.DoubleSide,
            alphaTest: 0.0,
        }
    );
    /** */
    merkez: FikoVektor3D = new FikoVektor3D()
    /** */
    yaziMesh: THREE.Mesh;
    yaziGeometry: TextGeometry;
    /** */
    // sabitYon: boolean = true;
    $olay: any

    kontrolDegistiEvent = ($event: any) => this.kameraYonDegisti(this);

    constructor(public override sahne: FikoSahne, ismi?: string, yazi?: string, boyut: number = 0.3, renk: any = new THREE.Color(0xFFFF00)) {
        super();
        this.name = ismi ?? this.#__yazi;
        this.#__yazi = yazi ?? ismi;
        this.#__boyut = boyut;
        this.#__renk = renk;
        this.renderOrder = 999999; // En üstte çizilsin
        this.hazirla(sahne);
    }

    override async hazirla(sahne: FikoSahne) {
        super.hazirla(sahne);
        if (!Fiko3DYazi.anaYaziTipi) {
            Fiko3DYazi.anaYaziTipi = await this.yaziTipiOkuyucu.loadAsync('/js/three/fonts/droid/droid_serif_regular.typeface.json');
        }
        if (this.yaziGeometry) {
            this.yaziGeometry.dispose();
        }
        this.yaziGeometry = new TextGeometry(this.yazi ?? this.name, {
            font: Fiko3DYazi.anaYaziTipi,
            size: this.boyut,
            // height: 0.03,
            curveSegments: 12,
            bevelEnabled: false,
        });
        this.materyal.color.set(this.#__renk);
        this.yaziMesh = new THREE.Mesh(this.yaziGeometry, this.materyal);

        // Render order - en üstte çizilsin (FikoEksen pattern'i)
        this.yaziMesh.renderOrder = 999999999;

        // Her frame'de depth buffer'ı temizle
        this.onBeforeRender = (renderer: any) => {
            renderer.clearDepth();
        };

        // this.yaziMesh.geometry.computeBoundingBox();
        // this.yaziMesh.geometry.boundingBox.getCenter(this.merkez)


        // this.quaternion?.copy(this.sahne.aktifKamera.quaternion)

        // if (this.sabitYon) {
        if (!this.sahne.anaGosterim.aktifKontrol.hasEventListener("change", this.kontrolDegistiEvent)) { }
        this.$olay = sahne.anaGosterim.aktifKontrol.addEventListener("change", this.kontrolDegistiEvent);
        // }
        this.ekle(this.yaziMesh);
        this.sahne.anaGosterim.ciz();
    }

    kameraYonDegisti(ev: any) {
        if (this.sabitYon) {
            this.setRotationFromMatrix(this.sahne.anaGosterim.aktifKamera.matrixWorld.clone())
            // 🚀 PERFORMANS: updateMatrixWorld kaldırıldı - render döngüsünde otomatik güncellenir
            this.matrixWorldNeedsUpdate = true;
        }
        if (this.sabitBoyut) {
            const factor = (this.sahne?.anaGosterim.aktifKamera?.top - this.sahne?.anaGosterim.aktifKamera?.bottom) / this.sahne?.anaGosterim.aktifKamera?.zoom;
            this.scale.set(1, 1, 1).multiplyScalar(factor * 1 / 10);
            // 🚀 PERFORMANS: updateMatrixWorld kaldırıldı - render döngüsünde otomatik güncellenir
            this.matrixWorldNeedsUpdate = true;
        }
    }

    override raycast(raycaster: Raycaster, intersects: Intersection[]): void {
        let kesisenler = raycaster.intersectObjects(this.children, true);

        if (kesisenler.length > 0) {
            intersects.push({
                object: this,
                distance: kesisenler[0].distance,
                point: kesisenler[0].point,
                face: null,
                faceIndex: null,
                index: null,
                instanceId: this.id,
                //@ts-ignore
                yon: { x: this.xYon, y: this.yYon, z: this.zYon },
                altObje: kesisenler[0].object,
                grup: this,
            });

        } else {
            return;
        }
    }

    yaziDegisti() {
        // Eğer mesh henüz oluşturulmadıysa (hazirla async), atla
        if (!this.yaziMesh) {
            return;
        }

        if (this.yaziGeometry) {
            this.yaziGeometry.dispose();
        }
        this.yaziGeometry = new TextGeometry(this.yazi ?? this.name, {
            font: Fiko3DYazi.anaYaziTipi,
            size: this.boyut,
            // height: 0.03,
            curveSegments: 12,
            bevelEnabled: false,
        });
        this.yaziMesh.geometry = this.yaziGeometry;
        this.sahne.anaGosterim.ciz();
    }

    renkDegisti() {
        // Eğer mesh henüz oluşturulmadıysa (hazirla async), atla
        if (!this.yaziMesh) {
            return;
        }

        this.materyal.color.set(this.#__renk);
        if (this.yaziMesh.material) {
            //@ts-ignore
            this.yaziMesh.material.dispose();
        }
        this.yaziMesh.material = this.materyal;
        this.sahne.anaGosterim.ciz();
    }

    dispose() {
        if (this.$olay) this.$olay();
        this.sahne.anaGosterim.aktifKontrol.removeEventListener(this.kontrolDegistiEvent)
    }
}